import { useState } from "react";
import ButtonSymphony from "elements/ButtonSymphony";
import InputSymphony from "elements/InputSymphony";
import { CSSProperties } from "react";
import SwitchSymphony, { SwitchType } from "elements/SwitchSymphony";
import ModalSymphony from "elements/ModalSymphony";
import Colors from "modules/Colors";
import TabsSymphony, { TabItem } from "elements/TabsSymphony";
import { makeKey, styx } from "modules/Utils";
import CustomAvatar from "components/ProfileDropdown/CustomAvatar";
import useBrand from "Hooks/useBrand";
import Loader from "elements/Loader";
import LoaderOverlay from "elements/LoaderOverlay";
import Sty from "modules/Sty";
import TagSymphony from "elements/TagSymphony";
import Icon, { IMAGE_MAP, ICON_MAP } from "elements/Icon";
import BrandInfo from "elements/BrandInfo";
import { Light as SyntaxHighlighter } from 'react-syntax-highlighter';
import { atomOneDark } from 'react-syntax-highlighter/dist/esm/styles/hljs';
import DebugBox from "components/shareable/DebugBox";
import { useNavbar } from "Hooks/useNavbar";
import ConnectionsList from "elements/ConnectionsList";

// SyntaxHighlighter.registerLanguage('jsx', jsx);

const purpleTags = [
    { title: 'Purple Tag 1', id: 'purpleTag1' },
    { title: 'Purple Tag 2', id: 'purpleTag2' },
    { title: 'Purple Tag 3', id: 'purpleTag3' },
    { title: 'Purple Tag 4', id: 'purpleTag4' },
]

const greenTags = [
    { title: 'Green Tag 1 Clickable', id: 'greenTag1' },
    { title: 'Green Tag 2 Clickable', id: 'greenTag2' },
    { title: 'Green Tag 3 Clickable', id: 'greenTag3' },
    { title: 'Green Tag 4 Clickable', id: 'greenTag4' },
]

const yellowTags = [
    { title: 'Yellow Tag 1', id: 'yellowTag1' },
    { title: 'Yellow Tag 2', id: 'yellowTag2' },
    { title: 'Yellow Tag 3', id: 'yellowTag3' },
    { title: 'Yellow Tag 4', id: 'yellowTag4' },
]

const redTags = [
    { title: 'Red Tag 1', id: 'redTag1' },
    { title: 'Red Tag 2', id: 'redTag2' },
    { title: 'Red Tag 3', id: 'redTag3' },
    { title: 'Red Tag 4', id: 'redTag4' },
]

const greyTags = [
    { title: 'Grey Tag 1 Removable', id: 'greyTag1' },
    { title: 'Grey Tag 2 Removable', id: 'greyTag2' },
    { title: 'Grey Tag 3 Removable', id: 'greyTag3' },
    { title: 'Grey Tag 4 Removable', id: 'greyTag4' },
]

const myTabs = [
    { id: 'tab1', title: 'Tab 1' },
    { id: 'tab2', title: 'Tab 2' },
    { id: 'tab3', title: 'Tab 3' },
]

const dotTabs = [
    { id: 'dot1', title: 'Dot 1' },
    { id: 'dot2', title: 'Dot 2' },
    { id: 'dot3', title: 'Dot 3' },
]

const numberTabs = [
    { id: 'num1', title: 'Number 1' },
    { id: 'num2', title: 'Number 2' },
    { id: 'num3', title: 'Number 3' },
]

const ElementsPage = () => {
    const { isCollapsed, isHoverSmallSidebar } = useNavbar();
    const { currentBrand, getBrandImage } = useBrand();

    const [text, setText] = useState('');
    const [switchesOn, setSwitchesOn] = useState(false);

    const [isDefaultModalOpen, setIsDefaultModalOpen] = useState<boolean>(false);
    const [isSmallModalOpen, setIsSmallModalOpen] = useState<boolean>(false);
    const [isLargeModalOpen, setIsLargeModalOpen] = useState<boolean>(false);
    const [isCustomWidthModalOpen, setIsCustomWidthModalOpen] = useState<boolean>(false);
    const [isFullScreenModalOpen, setIsFullScreenModalOpen] = useState<boolean>(false);
    const [isIsolatedModalOpen, setIsIsolatedModalOpen] = useState<boolean>(false);

    const [activeTab, setActiveTab] = useState(myTabs[0]);
    const [activeDotTab, setActiveDotTab] = useState(dotTabs[0]);
    const [activeNumberTab, setActiveNumberTab] = useState(numberTabs[0]);

    // Sample connections data for ConnectionsList
    const sampleConnections = [
        {
            id: 'spotify',
            name: 'Spotify',
            icon: 'spotify',
            isConnected: true,
            connectedText: 'Connected: Taylor Swift',
        },
        {
            id: 'tiktok',
            name: 'TikTok',
            icon: 'tiktok',
            isConnected: false,
            subtitle: 'Connect TikTok profile',
        },
        {
            id: 'instagram',
            name: 'Instagram',
            icon: 'instagram',
            isConnected: true,
            connectedText: 'Connected: @taylorswift',
        },
    ];

    /** Controls visibility of the full screen loader overlay */
    const [isFullScreenLoaderVisible, setIsFullScreenLoaderVisible] = useState<boolean>(false);
    const [isFullScreenTransparentLoaderVisible, setIsFullScreenTransparentLoaderVisible] = useState<boolean>(false);

    // NOTE: render()
    return (
        <div className="elementsPageComponent" style={sty.elementsPageComponent}>
            <DebugBox
                alwaysShow
                data={{
                    isCollapsed,
                    isHoverSmallSidebar,
                }}
            />
            {/* TYPOGRAPHY */}
            <div className="elementsPageTypography" style={sty.elementsRow}>
                <div style={Sty.text}>text: Text</div> •
                <div style={Sty.text14}>text14: Text 14</div> •
                <div style={Sty.text18}>text18: Text 18</div> •
                <div style={Sty.text20}>text20: Text 20</div> •
                <div style={Sty.text14grey}>text14grey: Text 14 Grey</div> •
                <div style={Sty.text16grey}>text16grey: Text 16 Grey</div> •
                <div style={Sty.text20grey}>text20grey: Text 20 Grey</div> •
                <div style={Sty.text18bold}>text18bold: Text 18 Bold</div> •
                <div style={Sty.text24bold}>text24bold: Text 24 Bold</div>
            </div>
            {/* BUTTONS */}
            <div className="elementsPageButtons1" style={sty.elementsRow}>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                >
                    ButtonSymphony
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    size="small"
                >
                    ButtonSymphony
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    size="large"
                >
                    ButtonSymphony
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    color="green"
                >
                    green
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    color="red"
                >
                    red
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    color="yellow"
                >
                    yellow
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    color="white"
                >
                    white
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    color="black"
                >
                    black
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    color="grey"
                >
                    grey
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    color="connected"
                >
                    connected
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    isLoading
                >
                    Loading Button
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    isLoading
                    loadingText="Loading..."
                >
                    Loading Button
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    disabled
                >
                    Disabled Button
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    isLoading
                    loadingText="Loading..."
                    disabled
                >
                    Disabled Loading Button
                </ButtonSymphony>
            </div>

            <div className="elementsPageButtons2" style={sty.elementsRow}>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="outlined"
                >
                    ButtonSymphony
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="outlined"
                    size="small"
                >
                    ButtonSymphony
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="outlined"
                    size="large"
                >
                    ButtonSymphony
                </ButtonSymphony>

                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="outlined"
                    color="green"
                >
                    green
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="outlined"
                    color="red"
                >
                    red
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="outlined"
                    color="yellow"
                >
                    yellow
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="outlined"
                    color="white"
                >
                    white
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="outlined"
                    color="black"
                >
                    black
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="outlined"
                    color="grey"
                >
                    grey
                </ButtonSymphony>
            </div>

            <div className="elementsPageButtons3" style={sty.elementsRow}>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="text"
                >
                    ButtonSymphony
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="text"
                    size="small"
                >
                    ButtonSymphony
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="text"
                    size="large"
                >
                    ButtonSymphony
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="text"
                    color="green"
                >
                    green
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="text"
                    color="red"
                >
                    red
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="text"
                    color="yellow"
                >
                    yellow
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="text"
                    color="white"
                >
                    white
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="text"
                    color="black"
                >
                    black
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => { }}
                    variant="text"
                    color="grey"
                >
                    grey
                </ButtonSymphony>
            </div>

            {/* TEXT INPUTS */}
            <div className="elementsPageTextInputs" style={sty.elementsCol}>
                <InputSymphony
                    className="elementsPageTextInput"
                    onChange={(valueText) => setText(valueText)}
                    placeholder="Text input placeholder"
                    value={text}
                />

                <InputSymphony
                    className="elementsPageTextInput"
                    onChange={(valueText) => setText(valueText)}
                    placeholder="Text input with search"
                    value={text}
                    isSearch
                    onSearch={() => { }}
                />

                <InputSymphony
                    className="elementsPageTextInput"
                    onChange={(valueText) => setText(valueText)}
                    placeholder="Text input with label"
                    value={text}
                    isSearch
                    onSearch={() => { }}
                    label="Text Input Label"
                />
            </div>

            <div className="elementsPageSwitches" style={sty.elementsCol}>
                {/* SWITCHES */}
                <SwitchSymphony
                    className="elementsPageSwitch"
                    onChange={() => setSwitchesOn(!switchesOn)}
                    checked={switchesOn}
                />
                <SwitchSymphony
                    className="elementsPageSwitch"
                    onChange={() => setSwitchesOn(!switchesOn)}
                    checked={switchesOn}
                    label="Switch Label"
                />
                <SwitchSymphony
                    className="elementsPageSwitch"
                    onChange={() => setSwitchesOn(!switchesOn)}
                    checked={switchesOn}
                    label="Switch Label disabled"
                    disabled
                />
                <SwitchSymphony
                    className="elementsPageSwitch"
                    onChange={() => setSwitchesOn(!switchesOn)}
                    checked={switchesOn}
                    label="Switch Label top"
                    labelPlacement="top"
                />
                <SwitchSymphony
                    className="elementsPageSwitch"
                    onChange={() => setSwitchesOn(!switchesOn)}
                    checked={switchesOn}
                    label="Switch Label right"
                    labelPlacement="right"
                />
                <SwitchSymphony
                    className="elementsPageSwitch"
                    onChange={() => setSwitchesOn(!switchesOn)}
                    checked={switchesOn}
                    label="Switch Label bottom"
                    labelPlacement="bottom"
                />
                <SwitchSymphony
                    className="elementsPageSwitch"
                    onChange={() => setSwitchesOn(!switchesOn)}
                    checked={switchesOn}
                    color="green"
                />
                <SwitchSymphony
                    className="elementsPageSwitch"
                    onChange={() => setSwitchesOn(!switchesOn)}
                    checked={switchesOn}
                    color="red"
                />
                {/* CHECKBOXES */}
                <SwitchSymphony
                    className="elementsPageSwitch"
                    onChange={() => setSwitchesOn(!switchesOn)}
                    checked={switchesOn}
                    type={SwitchType.CHECKBOX}
                />
                <SwitchSymphony
                    className="elementsPageSwitch"
                    onChange={() => setSwitchesOn(!switchesOn)}
                    checked={switchesOn}
                    type={SwitchType.CHECKBOX}
                    label="Checkbox Label left"
                    labelPlacement="left"
                />
                <SwitchSymphony
                    className="elementsPageSwitch"
                    onChange={() => setSwitchesOn(!switchesOn)}
                    checked={switchesOn}
                    type={SwitchType.CHECKBOX}
                    color="green"
                />
                <SwitchSymphony
                    className="elementsPageSwitch"
                    onChange={() => setSwitchesOn(!switchesOn)}
                    checked={switchesOn}
                    type={SwitchType.CHECKBOX}
                    color="red"
                />

                {/* RADIO BUTTONS */}
                <SwitchSymphony
                    className="elementsPageSwitch"
                    onChange={() => setSwitchesOn(!switchesOn)}
                    checked={switchesOn}
                    type={SwitchType.RADIO}
                />
                <SwitchSymphony
                    className="elementsPageSwitch"
                    onChange={() => setSwitchesOn(!switchesOn)}
                    checked={switchesOn}
                    type={SwitchType.RADIO}
                    color="green"
                />
                <SwitchSymphony
                    className="elementsPageSwitch"
                    onChange={() => setSwitchesOn(!switchesOn)}
                    checked={switchesOn}
                    type={SwitchType.RADIO}
                    color="red"
                />

            </div>

            {/* BRAND INFO */}
            <div className="elementsPageBrandInfo" style={sty.elementsCol}>
                <BrandInfo
                    className="elementsPageBrandInfoDefault"
                    brandName="Example Brand"
                    brandImage="https://via.placeholder.com/40"
                    brandSlug="examplebrand"
                />
                <BrandInfo
                    className="elementsPageBrandInfoSmall"
                    brandName="Example Brand"
                    brandImage="https://via.placeholder.com/24"
                    brandSlug="examplebrand"
                    variant="small"
                />
                <BrandInfo
                    className="elementsPageBrandInfoNoImage"
                    brandName="Brand Without Image"
                    brandSlug="nobrandimage"
                />
                <BrandInfo
                    className="elementsPageBrandInfoNoSlug"
                    brandName="Brand Without Slug"
                    brandImage="https://via.placeholder.com/40"
                    showSlug={false}
                />
                <BrandInfo
                    className="elementsPageBrandInfoCustomColor"
                    brandName="Custom Color Brand"
                    brandImage="https://via.placeholder.com/40"
                    brandSlug="customcolor"
                    titleColor="#00ff00"
                />
            </div>

            {/* MODALS */}
            <div className="elementsPageModals" style={sty.elementsRow}>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => setIsDefaultModalOpen(true)}
                >
                    Default Modal
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => setIsSmallModalOpen(true)}
                >
                    Small Modal
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => setIsLargeModalOpen(true)}
                >
                    Large Modal
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => setIsCustomWidthModalOpen(true)}
                >
                    Custom Width Modal
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => setIsFullScreenModalOpen(true)}
                >
                    Full Screen Modal
                </ButtonSymphony>
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => setIsIsolatedModalOpen(true)}
                >
                    Modal with Isolated Content
                </ButtonSymphony>

                <ModalSymphony
                    className="elementsPageModal"
                    isOpen={isDefaultModalOpen}
                    onClose={() => setIsDefaultModalOpen(false)}
                    title="Modal Title"
                    subtitle="Modal subtitle"
                    onClickButtonLeft={() => { }}
                    onClickButtonRight={() => { }}
                    buttonLeftText="Left Button"
                    buttonRightText="Right Button"
                >
                    This is the default modal.  This modal has a static header and subtitle that CANNOT be changed. <br /><br />Use Isolated Modal for more control over the modal
                </ModalSymphony>
                <ModalSymphony
                    className="elementsPageModal"
                    isOpen={isSmallModalOpen}
                    onClose={() => setIsSmallModalOpen(false)}
                    title="Modal Title"
                    subtitle="Modal subtitle"
                    size="small"
                    style={{ backgroundColor: Colors.purpleLight, padding: 24, borderRadius: 16 }}
                >
                    This is the small modal.
                </ModalSymphony>
                <ModalSymphony
                    className="elementsPageModal"
                    isOpen={isLargeModalOpen}
                    onClose={() => setIsLargeModalOpen(false)}
                    title="Modal Title"
                    subtitle="Modal subtitle"
                    size="large"
                    style={{ backgroundColor: Colors.purpleLight, padding: 24, borderRadius: 16 }}
                >
                    This is the large modal.
                </ModalSymphony>
                <ModalSymphony
                    className="elementsPageModal"
                    isOpen={isCustomWidthModalOpen}
                    onClose={() => setIsCustomWidthModalOpen(false)}
                    title="Modal Title"
                    subtitle="Modal subtitle"
                    maxWidth={500}
                    style={{ backgroundColor: Colors.purpleLight, padding: 24, borderRadius: 16 }}
                >
                    This is the custom width modal using fullWidth.
                </ModalSymphony>
                <ModalSymphony
                    className="elementsPageModal"
                    isOpen={isFullScreenModalOpen}
                    onClose={() => setIsFullScreenModalOpen(false)}
                    title="Modal Title"
                    subtitle="Modal subtitle"
                    fullScreen
                    style={{ backgroundColor: Colors.purpleLight, padding: 24, borderRadius: 16 }}
                >
                    This is the fullScreen modal.
                </ModalSymphony>

                <ModalSymphony
                    className="elementsPageModal"
                    isOpen={isIsolatedModalOpen}
                    onClose={() => setIsIsolatedModalOpen(false)}
                    isIsolateModalContent
                    style={{ backgroundColor: Colors.purpleLight, padding: 24 }}
                >
                    <h2>Isolated Content Modal</h2>
                    <p>This modal has complete control over its content without the default header.</p>
                    <ButtonSymphony
                        className="elementsPageButton"
                        onClick={() => setIsIsolatedModalOpen(false)}
                    >
                        Close Modal
                    </ButtonSymphony>
                </ModalSymphony>
            </div>

            {/* TABS */}
            <div className="elementsPageTabs" style={styx(sty.elementsCol, sty.tabsContainer)}>
                <div>
                    For tabs, we use:
                    <SyntaxHighlighter
                        language="jsx"
                        style={atomOneDark}
                        customStyle={sty.codeBlock}
                    >
                        {`
import TabSymphony from "components/shareable/TabSymphony";

const myTabs = [
    {
        id: 'tab1',
        title: 'Tab 1',
    },
    {
        id: 'tab2',
        title: 'Tab 2',
    },
]

const [currentTab, setCurrentTab] = useState(myTabs[0]);

<TabsSymphony
    className="campaignViewTabs"
    tabs={myTabs}
    value={myTab}
    onChange={onChangeMyTab}
/>

<TabSymphony
    className="tab1"
    visible={myTab === 'tab1'}
>
    stuff here
</TabSymphony>
<TabSymphony
    className="tab2"
    visible={myTab === 'tab2'}
>
    stuff here
</TabSymphony>
                        `}
                    </SyntaxHighlighter>
                </div>
                <TabsSymphony
                    className="elementsPageTabs"
                    style={sty.tabsBackground}
                    tabs={myTabs}
                    selectedTab={activeTab}
                    onChange={(tab) => setActiveTab(tab as TabItem)}
                />
                <div>default</div>

                <TabsSymphony
                    className="elementsPageTabs"
                    style={sty.tabsBackground}
                    tabs={dotTabs}
                    selectedTab={activeDotTab}
                    onChange={(tab) => setActiveDotTab(tab as TabItem)}
                    type="dots"
                />
                <div>dots</div>

                <TabsSymphony
                    className="elementsPageTabs"
                    style={sty.tabsBackground}
                    tabs={numberTabs}
                    selectedTab={activeNumberTab}
                    onChange={(tab) => setActiveNumberTab(tab as TabItem)}
                    type="numbers"
                />
                <div>numbers</div>
            </div>

            {/* CUSTOM AVATAR */}
            <div style={styx(sty.elementsRow, { alignItems: 'flex-start' })}>
                <div style={sty.avatarContainer}>
                    <div>image doesn't exist</div>
                    <CustomAvatar
                        className="elementsPageCustomAvatar"
                        image={null}
                        size={40}
                    />
                </div>
                <div style={sty.avatarContainer}>
                    <div>uses isBorder with undefined image</div>
                    <CustomAvatar
                        className="elementsPageCustomAvatar"
                        image={null}
                        isBorder
                        size={40}
                    />
                </div>
                <div style={sty.avatarContainer}>
                    <div>uses getBrandImage() which is robust, it grabs an image from wherever it can in currentBrand.connections</div>
                    <CustomAvatar
                        className="elementsPageCustomAvatar"
                        image={getBrandImage()}
                        size={40}
                    />
                </div>
                <div style={sty.avatarContainer}>
                    <div>uses currentBrand as brandOverride</div>
                    <CustomAvatar
                        className="elementsPageCustomAvatar"
                        brandOverride={currentBrand}
                        size={40}
                    />
                </div>

            </div>

            {/* LOADER */}
            <div style={sty.elementsRow}>
                <Loader
                    color="purple" // NOTE: this is default
                    size={40}
                />
                <Loader
                    color="white"
                    size={60}
                />
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => setIsFullScreenLoaderVisible(true)}
                >
                    Full Screen Loader
                </ButtonSymphony>
                {isFullScreenLoaderVisible &&
                    <LoaderOverlay
                        className="elementsPageLoaderOverlay"
                        title="Loading..."
                    >
                        <ButtonSymphony
                            className="elementsPageButton"
                            onClick={() => setIsFullScreenLoaderVisible(false)}
                            color="white"
                        >
                            Close Loader
                        </ButtonSymphony>
                    </LoaderOverlay>
                }
                <ButtonSymphony
                    className="elementsPageButton"
                    onClick={() => setIsFullScreenTransparentLoaderVisible(true)}
                >
                    Full Screen Transparent Loader
                </ButtonSymphony>
                {isFullScreenTransparentLoaderVisible &&
                    <LoaderOverlay
                        className="elementsPageLoaderOverlay"
                        title="Loading..."
                        isTransparent
                    >
                        <ButtonSymphony
                            className="elementsPageButton"
                            onClick={() => setIsFullScreenTransparentLoaderVisible(false)}
                            color="white"
                        >
                            Close Loader
                        </ButtonSymphony>
                    </LoaderOverlay>
                }
            </div>

            {/* TAGS */}
            <div className="tagsContainer" style={{ display: 'flex', gap: 8, flexDirection: 'column' }}>
                <div style={sty.elementsRow}>
                    {purpleTags.map((tag, index) => (
                        <TagSymphony
                            key={makeKey('purple-tag', tag.id, index)}
                            className="elementsPageTag"
                            title={tag.title}
                            color="purple"
                        />
                    ))}
                </div>

                <div style={sty.elementsRow}>
                    {greenTags.map((tag, index) => (
                        <TagSymphony
                            key={makeKey('green-tag', tag.id, index)}
                            className="elementsPageTag"
                            title={tag.title}
                            color="green"
                            onClick={() => alert('clicked')}
                        />
                    ))}
                </div>

                <div style={sty.elementsRow}>
                    {yellowTags.map((tag, index) => (
                        <TagSymphony
                            key={makeKey('yellow-tag', tag.id, index)}
                            className="elementsPageTag"
                            id={tag.id}
                            title={tag.title}
                            color="yellow"
                        />
                    ))}
                </div>

                <div style={sty.elementsRow}>
                    {redTags.map((tag, index) => (
                        <TagSymphony
                            key={makeKey('red-tag', tag.id, index)}
                            className="elementsPageTag"
                            tag={tag}
                            color="red"
                            isHashTag
                        />
                    ))}
                </div>

                <div style={styx(
                    sty.elementsRow,
                    {
                        gap: 8,
                        display: 'flex',
                        flexWrap: 'wrap',
                        backgroundColor: 'white',
                        padding: 16,
                        borderRadius: 16,
                        width: 'fit-content',
                    }
                )}>
                    {greyTags.map((tag, index) => (
                        <TagSymphony
                            key={makeKey('grey-tag', tag.id, index)}
                            className="elementsPageTag"
                            tag={tag}
                            color="grey"
                            onRemove={() => alert('removed')}
                        />
                    ))}
                </div>
            </div>

            {/* ICONS */}
            <SyntaxHighlighter
                language="jsx"
                style={atomOneDark}
                customStyle={sty.codeBlock}
            >
                {`
<Icon
    className="elementsPageIcon"
    icon={iconName}
    size={24}
/>`
                }
            </SyntaxHighlighter>
            <div className="iconsContainer" style={{ display: 'flex', gap: 8, flexDirection: 'row', flexWrap: 'wrap' }}>
                {Object.keys(ICON_MAP).map((icon, index) => {
                    return (
                        <div
                            key={makeKey('icon', icon, index)}
                            className="iconContainer"
                            style={sty.iconContainer}
                        >
                            <Icon
                                className="elementsPageIcon"
                                icon={icon}
                                size={32}
                            />
                            <div className="iconName">{icon}</div>
                        </div>
                    )
                })}
                {Object.keys(IMAGE_MAP).map((icon, index) => (
                    <div
                        key={makeKey('icon', icon, index)}
                        className="iconContainer"
                        style={sty.iconContainer}
                    >
                        <Icon
                            className="elementsPageIcon"
                            icon={icon}
                            size={32}
                        />
                        <div className="iconName">{icon}</div>
                    </div>
                ))}
            </div>

            {/* CONNECTIONS LIST */}
            <SyntaxHighlighter
                language="jsx"
                style={atomOneDark}
                customStyle={sty.codeBlock}
            >
                {`
<ConnectionsList
    className="connectionsListElement"
    connections={connections}
    onConnectionClick={(connection) => console.log('Connect:', connection)}
    onRemoveConnection={(connection) => console.log('Remove:', connection)}
    showRemoveButton={true}
/>`
                }
            </SyntaxHighlighter>
            <div className="connectionsListContainer" style={{ maxWidth: 500 }}>
                <ConnectionsList
                    className="connectionsListElement"
                    connections={sampleConnections}
                    onConnectionClick={(connection) => console.log('Connect:', connection)}
                    onRemoveConnection={(connection) => console.log('Remove:', connection)}
                    showRemoveButton={true}
                />
            </div>

        </div>
    )
}

const sty: Record<string, CSSProperties> = {
    elementsPageComponent: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        padding: 24,
    },
    elementsRow: {
        display: 'flex',
        gap: 16,
        flexDirection: 'row',
        alignItems: 'center',
        flexWrap: 'wrap',
    },
    elementsCol: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
    },
    isolatedModalContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: 16,
        alignItems: 'center',
        textAlign: 'center'
    },
    tabsContainer: {
        width: '100%',
        maxWidth: 800,
    },
    tabsBackground: {
        backgroundColor: 'white',
    },
    avatarContainer: {
        maxWidth: 240,
    },
    codeBlock: {
        backgroundColor: 'black',
        color: Colors.grey,
        paddingLeft: 16,
        paddingRight: 16,
        borderRadius: 16,
        fontSize: 14,
        fontFamily: 'monospace',
    },
    preDebugCode: {
        display: 'flex',
        fontSize: 14,
        gap: 4,
        margin: 0,
        paddingBottom: 10,
        background: 'transparent',
    },
    iconContainer: {
        display: 'flex',
        gap: 8,
        alignItems: 'center',
        flexDirection: 'column',
        border: `1px solid ${Colors.grey}`,
        padding: 8,
        borderRadius: 8,
    },
}

export default ElementsPage;